import { ValidatorRules } from '../../../../util/validator'
import { StrategyStepState } from '../strategy-slice'
import { validateNumberField } from './util'

export const riskManagedRules: ValidatorRules<StrategyStepState> = {
  riskManaged_protectionAsset: [
    (state: StrategyStepState) => ({
      isValid: !!state.selectedStrategy.riskManaged.protectionAsset
    })
  ],
  targetVolatility: (state: StrategyStepState) =>
    validateNumberField('targetVolatility', state.selectedStrategy.riskManaged.targetVolatility)
}
